export const getValuesForFirstAndLast = (
  values: number[],
  sideValue: string | number,
  general: string | number,
) => {
  const data = new Array(values.length).fill(general);
  data[0] = sideValue;
  data[data.length - 1] = sideValue;

  return data;
};
